var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEditi = function SvgEditi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: props.color || 'currentColor',
    "data-name": "Group 5690"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.758 6.347-3.1-3.1a.927.927 0 0 0-1.311.053l-1.361 1.362 4.352 4.352L20.7 7.653a.927.927 0 0 0 .058-1.306",
    "data-name": "Path 4288"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.807 15.841a1.02 1.02 0 0 0-.291.576l-.507 3.612a.835.835 0 0 0 .962.962l3.612-.507a1.02 1.02 0 0 0 .576-.291l9.99-9.993L13.8 5.851z",
    "data-name": "Path 4289"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    "data-name": "Rectangle 1356"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEditi);
export default ForwardRef;